module.exports = __webpack_public_path__ + "static/media/sds_1.2ae39df9.png";